module.exports = __webpack_public_path__ + "media/images/foodpanda-logo@2x-eb9be1d54a77a58852c53b5fd299dfa5.webp";